<style scoped="scoped" lang="scss">
.read_title {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  margin-top: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei UI;
  color: #303133;

}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/msg/im/page"
        getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('zhuangtai')">
            <!--            <yi_dictionary_select :type="'CUSTOMER_PARAMETER'" :ids.sync="yt.conditions.type">-->
            <!--            </yi_dictionary_select>-->
            <el-select v-model="yt.conditions.status" @change="$forceUpdate()">
              <el-option :value="0" :label="$t('weidu')"></el-option>
              <el-option :value="1" :label="$t('yidu')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="searchBtn()" type="primary"
                plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({orderBy: 'createTime desc'})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button  v-if="utils.checkPower('web_system_message_management_allRead')" type="primary" @click="allRead()" :loading="yt.editObj.loading"
            size="mini" :disabled="swicthRead">
          {{$t('quanbubiaoweiyidu')}}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text"
                @click="yt.showEditDialog('xiaoxiqiangqing', scope.row,'w2',beforeShowEditDialog);getRead()">
              {{$t('chakan')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <template #xiaoxibiaoti="scope">
        <span @click="yt.showEditDialog('xiaoxiqiangqing', scope.row,'w2',beforeShowEditDialog);getRead()"
            style="color: #419FFF">{{scope.row.title}}</span>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 查看/消息详情 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'xiaoxiqiangqing'">
        <div class="dialog-scroller">
          <div style="width: 100%;height: 1px;border: 1px solid #E4E7ED;"></div>
          <!--标题-->
          <div class="read_title">
            {{readDetails.title | ellipsis}}
          </div>
          <!--发送人、发送时间-->
          <div
              style="display: flex;flex-wrap: nowrap;color: #606266;justify-content: center;align-items: center;margin-top: 18px">
            <span>
              {{$t('fasongren')}}: {{readDetails.sender.nickname}}
            </span>
            <span style="margin-left: 30px">
               {{$t('fasongshijian')}}: {{dateFormat(readDetails.createTime)}}
            </span>
          </div>
          <!--内容-->
          <div style="margin: 40px; color: #606266" >
            <p v-html="readDetails.msg" style="white-space:pre-wrap"></p>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_system_message_management_list',
  data() {
    return {
      readValue: false,
      swicthRead: false,
      readDetails: null,
      resultTotal: null,
      readId: null,
      unreadSizeTtotal: '',
      columns: [
        //     {
        //   label: 'xuhao',
        //   prop: 'serialNum',
        //   width: 180
        // },
        {
          label: 'zhuangtai',
          type: 'tag',
          prop: 'status',
          width: 180,
          tags: {
            0: {
              color: '#E6A23C',
              text: this.$t('weidu')
            },
            1: {
              color: '#909399',
              text: this.$t('yidu')
            }
          },
        }, {
          label: 'xiaoxibiaoti',
          prop: 'title',
          type: "slot",
          width: 180
        }, {
          label: 'fasongshijian',
          prop: 'createTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm',
          width: 180
        }, {
          label: 'fasongren',
          prop: 'sendUser.nickname',
          // width: 180
        }, {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }]
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return '';
      if (value.length > 30) {
        return value.slice(0, 30) + '...'
      }
      return value
    },
  },
  watch: {
    "yt.isShowEditDialog": {
      handler(n) {
        if (n == false) {
          this.yt.get(1);
          this.getUnreadSize()
        }
      },
      immediate: false,
      deep: true
    },
    resultTotal: {
      handler(n) {
        console.log('fffffggg', n)
        if (n !== 0) {
          this.swicthRead = false
          this.yt.get(1);
        }else {
          this.yt.get(1);
        }
      },
      immediate: false,
      deep: true
    },
    unreadSizeTtotal:{
      handler(n) {
        console.log('fbbbbb', n)
        // if (n !== 0) {
        //   this.swicthRead = false
        //   this.yt.get(1);
        // }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      }
      this.yt.get(1);
      this.getUnreadSize();
      this.getRecentList();
    }, 300)

  },
  mounted() {
    this.utils.event_hub.$on('READ_REFRESHS', result => {
      this.resultTotal = result
      console.log('ffffffddwww', result)
    })
  },
  methods: {
    allRead(){
      this.yt.get(1);
      this.getReadAll();
      this.getUnreadSize()
      setTimeout(()=>{
        this.yt.get(1);
      },300)
      this.utils.event_hub.$emit('READ_REFRESH');
    },
    //搜索
    searchBtn() {
      this.yt.get(1);
      this.getUnreadSize();
      this.utils.event_hub.$emit('READ_REFRESH');
    },
    //全部设置为已读
    async getReadAll() {
      return await this.http.post('/web/msg/im/readAll').then(response => {
      }).catch((error) => {
        this.utils.errorMessage(error)
      })
    },
    //未读消息总数量
    async getUnreadSize() {
      let response = await this.http.get('/web/msg/im/unreadSize', {
        params: {
          pageNum: 1,
          pageSize: 999
        }
      })
      this.unreadSizeTtotal = response.data
      //若未读消息总数量为0，则全部标为已读按钮置灰
      if (this.unreadSizeTtotal == 0) {
        this.swicthRead = true
      }else {
        this.swicthRead = false
      }
    },
    beforeShowEditDialog(editObj) {
      this.readId = editObj.id
      this.utils.event_hub.$emit('READ_REFRESH');
      // this.getRead();
      // this.getUnreadSize()
      return editObj
    },
    //查看消息
    async getRead() {
      let response = await this.http.get('/web/msg/im/read', {
        params: {
          id: this.readId,
          pageNum: 1,
          pageSize: 999
        }
      })
      this.readDetails = response.data
      // this.yt.get(1);
      console.log('getRead', this.readDetails)
    },

    // 日期转换
    dateFormat(time) {
      const t = new Date(time)
      // 日期格式
      const format = 'Y-m-d h:i:s'
      let year = t.getFullYear()
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1
      let day = t.getDate()
      let hours = t.getHours()
      let minutes = t.getMinutes()
      let seconds = t.getSeconds()
      month = month > 9 ? month : `0${month}`
      day = day > 9 ? day : `0${day}`
      hours = hours > 9 ? hours : `0${hours}`
      minutes = minutes > 9 ? minutes : `0${minutes}`
      seconds = seconds > 9 ? seconds : `0${seconds}`
      const hash = {
        'Y': year,
        'm': month,
        'd': day,
        'h': hours,
        'i': minutes,
        's': seconds
      }
      return format.replace(/\w/g, o => {
        return hash[o]
      })
    },
  },
};
</script>
